import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconPlaceholder.svg",
  "use": "IconPlaceholder.svg-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"IconPlaceholder.svg\">\n<path d=\"M1 9C1 4.58172 4.58172 1 9 1H21C25.4183 1 29 4.58172 29 9V21C29 25.4183 25.4183 29 21 29H9C4.58172 29 1 25.4183 1 21V9Z\" stroke=\"white\" stroke-opacity=\"0.5\" stroke-linejoin=\"round\" stroke-dasharray=\"3 3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol